export default [
  {
    name: 'About',
    path: '/about'
  },
  {
    name: 'Client',
    path: '/client'
  },
  {
    name: 'Team',
    path: '/team'
  },
  {
    name: 'Apple',
    path: '/apple'
  },
  {
    name: 'Media',
    path: '/media',
    children: [
      {
        name: 'News',
        path: '/news'
      },
      {
        name: 'Awards',
        path: '/awards'
      },
      {
        name: 'LiveVideo',
        path: '/live-video'
      }
    ]
  },
  {
    name: 'Contacts',
    path: '/contacts'
  }
/*  {
    name: 'WhatWeDo',
    path: '#',
    children: [
      {
        name: 'SmartVenues',
        path: '/smart-venues'
      },
      {
        name: 'SmartConstruction',
        path: '/smart-construction'
      }
    ]
  },
  {
    name: 'Solutions',
    path: '/solutions',
    children: [
      {
        name: 'Construction',
        path: '/construction'
      },
      {
        name: 'Retail',
        path: '/retail'
      },
      {
        name: 'HealthCare',
        path: '/health-care'
      },
      {
        name: 'EventVenues',
        path: '/event-venues'
      },
      {
        name: 'Transportation',
        path: '/transportation'
      },
      {
        name: 'Hospitality',
        path: '/hospitality'
      }
    ]
  },
  // {
  //   name: 'Platforms',
  //   path: '/platforms'
  // },

  {
    name: 'HowItWorks',
    path: '/how-it-works'
  }
  */
]
